import Papa from "papaparse";
import { getSessionData } from "../interceptors/localStorageService";

export const preventTextInput = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

export const preventNumericInput = (event) => {
  if (/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};
export const range = (start, end, step = 1) => {
  const length = Math.ceil((end - start) / step);
  return Array.from({ length }, (_, i) => start + i * step);
};

export const validateBirthDate = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }

  const today = new Date();
  const selectedDate = new Date(value);

  const minDate = new Date(
    today.getFullYear() - 70,
    today.getMonth(),
    today.getDate()
  );
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  if (selectedDate >= minDate && selectedDate <= maxDate) {
    return Promise.resolve();
  }

  if (selectedDate < maxDate) {
    return Promise.reject(new Error("Maximum required age is 70 years."));
  } else {
    return Promise.reject(new Error("Minimum required age is 18 years."));
  }
};

export const hexToRgba = (hex, opacity) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const getFileBase64AndType = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("No file provided"));
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      const fileType = file.type;

      resolve({ base64String, fileType });
    };

    reader.onerror = (error) => reject(error);
  });
};

export const downloadFile = (base64String, fileName, type) => {
  // Decode the Base64 string to a binary format
  const binaryString = window.atob(base64String);

  // Convert binary string to a typed array
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob from the typed array
  const blob = new Blob([byteArray], { type: type });

  // Create a temporary download link
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName || "download";

  // Trigger the download
  document.body.appendChild(link);
  link.click();

  // Clean up the link
  document.body.removeChild(link);
};

export const importJSON = (file) => {
  return new Promise((resolve, reject) => {
    if (!(file instanceof File)) {
      return reject(new Error("Expected a File"));
    }
    const reader = new FileReader();
    reader.onerror = () => {
      reader.abort();
      reject(new Error("Failed to read file"));
    };
    reader.onload = () => {
      try {
        const obj = JSON.parse(reader.result);
        resolve(obj);
      } catch (err) {
        reject(new Error("Invalid JSON"));
      }
    };
    reader.readAsText(file);
  });
};
export const exportJSON = (data, name = "export") => {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

export const createCSVParser = ({
  mandatoryFields = [],
  onSuccess = () => { },
  onError = () => { },
  onMissingFields = () => { },
  stateSetters = {},
}) => {
  const parseCSV = (info) => {
    return new Promise((resolve, reject) => {
      const { status } = info.file;
      if (status !== "done") {
        return;
      }

      const file = info.file.originFileObj;
      const fileExtension = file.name.split(".").pop();
      const isCSV = ["csv"].includes(fileExtension.toLowerCase());

      if (!isCSV) {
        const error = new Error(
          `Only CSV files are allowed. Received: ${fileExtension.toLowerCase()}`
        );
        onError(error);
        reject(error);
        return;
      }

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          try {
            if (results.errors.length > 0) {
              throw new Error(`Parse error: ${results.errors[0].message}`);
            }

            const headers = Object.keys(results.data[0]);

            // Validate mandatory fields
            const missingFields = mandatoryFields.filter(
              (field) =>
                !headers
                  .map((h) => h.toLowerCase())
                  .includes(field.toLowerCase())
            );

            if (missingFields.length > 0) {
              const error = new Error(
                `Missing mandatory fields: ${missingFields.join(", ")}`
              );
              onMissingFields(missingFields);
              reject(error);
              return;
            }

            // Clean the data
            const cleanedData = results.data.map((row) =>
              Object.fromEntries(
                Object.entries(row).map(([key, value]) => [
                  key,
                  typeof value === "string"
                    ? value.replace(/"/g, "").trim()
                    : value,
                ])
              )
            );

            const parsedData = {
              headers,
              data: cleanedData,
              raw: results.data,
              meta: results.meta,
            };
            console.log("stateSetters? ? ? ? ", stateSetters);
            // Update state if setters are provided
            const { setTableData, setTableColumns, setDataToBeSubmitted } =
              stateSetters;

            if (setTableColumns) {
              setTableColumns(
                headers.map((header) => ({
                  title: header,
                  dataIndex: header,
                  key: header,
                  editable: true,
                }))
              );
            } else {
              console.log("not availabele???");
            }

            if (setTableData) {
              setTableData(
                cleanedData.map((row, index) => ({ ...row, key: index }))
              );
            }

            if (setDataToBeSubmitted) {
              setDataToBeSubmitted({
                mandates: cleanedData,
              });
            }

            onSuccess(parsedData);
            resolve(parsedData);
          } catch (error) {
            onError(error);
            reject(error);
          }
        },
        error: (error) => {
          onError(error);
          reject(error);
        },
      });
    });
  };

  return parseCSV;
};

export const getStorageKey = (userId) => `notifications_${userId}`;

export const loadNotificationsFromSession = (userId) => {
  const data = sessionStorage.getItem(getStorageKey(userId));
  return data ? JSON.parse(data) : [];
};

const getNotificationKey = (notification) =>
  notification?.notificationId || notification?.id || notification?.groupNotificationId;

export const normalizeNotification = (notification) => ({
  ...notification,
  id: notification?.id || notification?.notificationId || Date.now(),
  title: notification?.title || notification?.sender || "Notification",
  message: notification?.message || notification?.snippet || notification?.description || "",
  timestamp: notification?.timestamp || notification?.createdAt || new Date().toISOString(),
  read: notification?.read ?? notification?.isRead ?? false,
  action: notification?.action || notification?.link || notification?.data?.link,
});

export const setNotificationsInSession = (userId, notifications = []) => {
  const normalizedNotifications = notifications.map(normalizeNotification);
  sessionStorage.setItem(
    getStorageKey(userId),
    JSON.stringify(normalizedNotifications)
  );
  return normalizedNotifications;
};

export const mergeNotificationsInSession = (userId, notifications = []) => {
  const existingNotifications = loadNotificationsFromSession(userId);
  const notificationMap = new Map();

  [...notifications, ...existingNotifications]
    .map(normalizeNotification)
    .forEach((notification) => {
      const key = getNotificationKey(notification) || `${notification.timestamp}-${notification.message}`;
      if (!notificationMap.has(key)) {
        notificationMap.set(key, notification);
      }
    });

  const mergedNotifications = Array.from(notificationMap.values()).sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );

  sessionStorage.setItem(
    getStorageKey(userId),
    JSON.stringify(mergedNotifications)
  );
  return mergedNotifications;
};

export const saveNotificationsToSession = (userId, newNotification) =>
  mergeNotificationsInSession(userId, [newNotification]);

export const clearNotificationsFromSession = (userId) => {
  sessionStorage.removeItem(getStorageKey(userId));
};

export const formatFiltersForAPI = (filterValues, filterData) => {
  if (!filterData?.fields || !filterValues) {
    return { filters: [], searchText: "", searchFields: [] };
  }

  const filters = [];
  let searchText = "";
  let searchFields = [];

  console.log("Formatting filters for API:", filterValues);
  console.log("Filter data fields:", filterData.fields);

  Object.entries(filterValues).forEach(([fieldName, value]) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return;
    }

    const fieldConfig = filterData.fields.find((f) => f.name === fieldName);
    if (!fieldConfig) {
      console.warn(`No field config found for: ${fieldName}`);
      return;
    }

    console.log(
      `Processing field: ${fieldName}, type: ${fieldConfig.type}, value:`,
      value
    );

    if (fieldConfig.type === "search") {
      searchText = String(value);
      searchFields = fieldConfig.searchFields || [
        fieldConfig.beName || fieldConfig.name,
      ];
      return;
    }

    // Handle date range fields - supporting multiple formats
    if (fieldConfig.type === "daterange") {
      // Format 1: DatePicker.RangePicker returns [startDate, endDate]
      if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
        console.log("Processing daterange as array:", value);

        // Convert moment objects to strings if needed
        let startDate = value[0];
        let endDate = value[1];

        if (typeof startDate === "object" && startDate.format) {
          startDate = startDate.format("YYYY-MM-DD");
        }
        if (typeof endDate === "object" && endDate.format) {
          endDate = endDate.format("YYYY-MM-DD");
        }

        filters.push({
          field: fieldConfig.beName || fieldName,
          operator: "between",
          value: `${startDate},${endDate}`,
        });
        console.log("Added daterange filter:", {
          field: fieldConfig.beName || fieldName,
          operator: "between",
          value: `${startDate},${endDate}`,
        });
        return;
      }

      // Format 2: Separate start/end date fields using fieldConfig.names
      if (fieldConfig.names && fieldConfig.names.length === 2) {
        const startDateName = fieldConfig.names[0];
        const endDateName = fieldConfig.names[1];

        console.log(
          `Checking separate date fields: ${startDateName}, ${endDateName}`
        );
        console.log(
          `Values: ${filterValues[startDateName]}, ${filterValues[endDateName]}`
        );

        if (filterValues[startDateName] && filterValues[endDateName]) {
          let startDate = filterValues[startDateName];
          let endDate = filterValues[endDateName];

          // Convert moment objects to strings if needed
          if (typeof startDate === "object" && startDate.format) {
            startDate = startDate.format("YYYY-MM-DD");
          }
          if (typeof endDate === "object" && endDate.format) {
            endDate = endDate.format("YYYY-MM-DD");
          }

          filters.push({
            field: fieldConfig.beName || fieldName,
            operator: "between",
            value: `${startDate},${endDate}`,
          });
          console.log("Added separate daterange filter:", {
            field: fieldConfig.beName || fieldName,
            operator: "between",
            value: `${startDate},${endDate}`,
          });
        }
        return;
      }

      // Format 3: Single daterange field with object value like {start: date, end: date}
      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        (value.start || value.end)
      ) {
        if (value.start && value.end) {
          let startDate = value.start;
          let endDate = value.end;

          if (typeof startDate === "object" && startDate.format) {
            startDate = startDate.format("YYYY-MM-DD");
          }
          if (typeof endDate === "object" && endDate.format) {
            endDate = endDate.format("YYYY-MM-DD");
          }

          filters.push({
            field: fieldConfig.beName || fieldName,
            operator: "between",
            value: `${startDate},${endDate}`,
          });
          console.log("Added object daterange filter:", {
            field: fieldConfig.beName || fieldName,
            operator: "between",
            value: `${startDate},${endDate}`,
          });
        }
        return;
      }

      console.warn(
        `Daterange field ${fieldName} has unexpected value format:`,
        value
      );
      return;
    }

    // Handle regular fields
    const operator = fieldConfig.operator || "equals";
    const beName = fieldConfig.beName || fieldConfig.name;

    if (Array.isArray(value)) {
      filters.push({
        field: beName,
        operator: "in",
        value: value,
      });
    } else {
      filters.push({
        field: beName,
        operator: operator,
        value: value,
      });
    }
  });

  const result = {
    filters,
    searchText,
    searchFields,
  };

  console.log("Final formatted result:", result);
  return result;
};

// Build a standardized request payload for filtered list endpoints
// - Uses formatFiltersForAPI by default
// - Derives pageNumber from pagination.pageNumber, falling back to pagination.pageIndex, defaulting to 0
// - Includes pageSize and optional searchText/searchFields
export const buildFilterRequest = ({
  filterValues,
  filterData,
  pagination,
  options = {},
}) => {
  const {
    useFormatFilters = true,
    includeSearchBits = true,
    extra = {},
  } = options;

  const pageNumber = pagination?.pageNumber ?? pagination?.pageIndex ?? 0;
  const pageSize = pagination?.pageSize ?? 10;

  if (!useFormatFilters) {
    return {
      pageNumber,
      pageSize,
      ...extra,
    };
  }

  const { filters, searchText, searchFields } = formatFiltersForAPI(
    filterValues,
    filterData
  );

  const request = {
    pageNumber,
    pageSize,
    filters,
    ...extra,
  };

  if (includeSearchBits) {
    if (searchText) request.searchText = searchText;
    if (Array.isArray(searchFields) && searchFields.length > 0) {
      request.searchFields = searchFields;
    }
  }

  return request;
};


export const prepareFilterRequestForAll = (currentFilter, filterData, pagination) => {
  if (!filterData) return {};
  const { filters, searchText, searchFields } = formatFiltersForAPI(currentFilter, filterData);
  return {
    pageNumber: pagination.pageNumber,
    pageSize: pagination.pageSize,
    filters,
    ...(searchText && { searchText }),
    ...(searchFields.length > 0 && { searchFields })
  };
};


export const handleCopy = async (content, navigator, message) => {
  try {
    await navigator.clipboard.writeText(content);
    message.success("Copied to clipboard");
  } catch {
    message.error("Failed to copy");
  }
};

export function nowMs() {
  return Date.now ? Date.now() : new Date().getTime();
}

